"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _reactSlidingPane = _interopRequireDefault(require("react-sliding-pane"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _history = _interopRequireDefault(require("../../../helpers/history"));
var _APIcon = _interopRequireDefault(require("../APIcon"));
var _SidePaneChildren = _interopRequireDefault(require("./SidePaneChildren"));
require("react-sliding-pane/dist/react-sliding-pane.css");
require("./SidePane.css");
var _excluded = ["hideCloseLink", "classModifiers"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SidePane = /*#__PURE__*/function (_Component) {
  function SidePane(props) {
    var _this;
    _classCallCheck(this, SidePane);
    _this = _callSuper(this, SidePane, [props]);
    _defineProperty(_this, "getPropsFromChild", function (_ref) {
      var title = _ref.title,
        customClass = _ref.customClass,
        hideCloseLink = _ref.hideCloseLink,
        classModifiers = _ref.classModifiers,
        hideHeader = _ref.hideHeader;
      _this.setState({
        title: title,
        customClass: customClass,
        hideCloseLink: hideCloseLink,
        classModifiers: classModifiers,
        hideHeader: hideHeader
      });
    });
    _defineProperty(_this, "returnScrollPosition", function () {
      document.body.style.position = 'static';
      window.scroll(0, _this.state.scrollPosition);
    });
    _defineProperty(_this, "renderCloseIcon", function () {
      var classes = _this.getClasses();
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: _this.props.close,
        className: classes('close-button')
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "close",
        classModifiers: "big"
      }));
    });
    _defineProperty(_this, "closePane", function () {
      return _this.props.close(_this.props.name);
    });
    _this.unlisten = null;
    _this.state = {
      title: '',
      customClass: '',
      hideCloseLink: false,
      classModifiers: '',
      hideHeader: false,
      scrollPosition: 0
    };
    return _this;
  }
  _inherits(SidePane, _Component);
  return _createClass(SidePane, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      _reactModal["default"].setAppElement(this.modalRef);
      this.unlisten = _history["default"].listen(function (location, action) {
        if (action === 'POP' && _this2.props.isOpen) {
          _this2.props.close();
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var bodyPosition = document.body.style.position;
      if (!this.props.isOpen && bodyPosition === 'fixed') {
        this.returnScrollPosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
      this.unlisten = null;
    }
  }, {
    key: "getClasses",
    value: function getClasses() {
      return (0, _cssClassesHelper.getBEMClasses)(['ap-sidepane', this.state.customClass]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var t = this.props.t;
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        name = _this$props.name,
        data = _this$props.data,
        options = _this$props.options;
      var _this$state = this.state,
        hideCloseLink = _this$state.hideCloseLink,
        classModifiers = _this$state.classModifiers,
        otherProps = _objectWithoutProperties(_this$state, _excluded);
      var classes = this.getClasses();
      var Child = _SidePaneChildren["default"][name];
      var isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod/i);
      if (name && !Child) {
        console.error(t("SidePane Component named ".concat(name, " not found")));
        return null;
      }
      var sidePaneOptions = (0, _get["default"])(options, name, {});
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes(null, classModifiers),
        ref: function ref(_ref2) {
          return _this3.modalRef = _ref2;
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactSlidingPane["default"], _extends({
        className: classes('container', classModifiers),
        overlayClassName: classes('overlay', classModifiers),
        onAfterOpen: function onAfterOpen() {
          if (isMobile) {
            // set position after opening sidepane
            setTimeout(function () {
              _this3.setState({
                scrollPosition: window.pageYOffset
              });
              document.body.style.position = 'fixed';
            }, 500);
          }
        },
        onRequestClose: this.closePane,
        isOpen: isOpen
      }, otherProps), !hideCloseLink && this.renderCloseIcon(), Child && /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
        fallback: null
      }, /*#__PURE__*/_react["default"].createElement(Child, _extends({
        name: name,
        closeSidePane: this.closePane
      }, data, sidePaneOptions, {
        onSidePaneOpen: this.getPropsFromChild
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.isOpen) {
        var header = document.getElementsByClassName('slide-pane__header')[0];
        if (header && state.hideHeader) {
          header.classList.add('slide-pane__hide-header');
        }
      }
      return state;
    }
  }]);
}(_react.Component);
_defineProperty(SidePane, "propTypes", {
  isOpen: _propTypes["default"].bool.isRequired,
  close: _propTypes["default"].func.isRequired,
  hideCloseLink: _propTypes["default"].bool
});
_defineProperty(SidePane, "defaultProps", {
  customClass: 'custom-sidepane',
  options: {}
});
var _default = exports["default"] = (0, _reactI18next.withTranslation)('core')(SidePane);